import React from 'react'
import Switch from './Default'
import { FormControlLabel } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

export default withStyles({
  root: {
    margin: 0,
    borderBottom: '1px solid #ECEFF1',
  },
  fullWidthRoot: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: 0,
    borderBottom: '1px solid #ECEFF1',
  },
  label: {
    fontSize: 16,
    color: 'rgba(0, 0, 0, 0.54)',
  },
})(function ({ label, fullWidth, classes, ...props }) {
  return (
    <FormControlLabel
      classes={{
        root: fullWidth ? classes.fullWidthRoot : classes.root,
        label: classes.label,
      }}
      label={label}
      control={<Switch {...props} />}
      labelPlacement="start"
    />
  )
})
